import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useAnnouncement } from '../../hooks/useAnnouncement';

const AnnouncementBar = () => {
  const { text, image } = useAnnouncement();
  const [showImg, setShowImg] = useState(false);

  // Close on Escape.
  useEffect(() => {
    if (!showImg) return;
    const onKey = (e) => { if (e.key === 'Escape') setShowImg(false); };
    window.addEventListener('keydown', onKey);
    // Lock background scroll while modal is open.
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [showImg]);

  if (!text && !image) return null;

  const openPopup = () => { if (image) setShowImg(true); };

  // The image popup — rendered via portal to document.body so it escapes
  // any ancestor that has `transform`, `filter`, or `backdrop-filter`
  // (which would otherwise trap our `position: fixed` overlay inside the
  // ancestor's containing block and make the popup invisible / clipped).
  const popup = showImg && image ? createPortal(
    <div className="ann-modal-overlay" onClick={() => setShowImg(false)}>
      <div className="ann-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="ann-modal-close"
          onClick={() => setShowImg(false)}
          aria-label="Close"
          type="button"
        >×</button>
        <img src={image} alt="Announcement" className="ann-modal-img" />
        {text && <div className="ann-modal-text">{text}</div>}
      </div>
    </div>,
    document.body
  ) : null;

  return (
    <>
      <div className="ann-bar">
        {image && (
          <button
            className="ann-thumb-btn"
            onClick={openPopup}
            aria-label="Open announcement image"
            type="button"
          >
            <img src={image} alt="" />
          </button>
        )}
        <div
          className="ann-marquee"
          onClick={openPopup}
          style={{ cursor: image ? 'pointer' : 'default' }}
        >
          <div className="ann-marquee-track">
            <span className="ann-text">{text || '◆ Announcement'}</span>
            <span className="ann-sep">◆</span>
            <span className="ann-text">{text || '◆ Announcement'}</span>
            <span className="ann-sep">◆</span>
            <span className="ann-text">{text || '◆ Announcement'}</span>
          </div>
        </div>
      </div>
      {popup}
    </>
  );
};

export default AnnouncementBar;
